const SET_DISCUSSIONS = (state, payload) => {
  state.selectedCommunity.latestDiscussions = payload.discussionsByCommunityId;
  state.discussionsLoadedAll =
    payload.discussionsByCommunityId.results.length === 0;
};

export default SET_DISCUSSIONS;
